export function getSystemVersion() {
  return import.meta.env.VITE_VERSION;
}
